import React, { Component } from "react";
import GooglePicker from "react-google-picker";
import parameters from "../../../config/parameters";
import Wix from "Wix";
import WixBiService from '../../../utils/WixBIService';
import wixService from '../../../utils/wixService';
import axios from "axios"
import httpRequest from "../../../widget/api/httpRequests"
import { updateConnect ,updateErrorConnect} from "../../../actions/updateConnectActions";
import {retrievePermissionsListByFileId} from '../../../widget/api/PermissionsAPI';
import setDataPublic from "../../../actions/dataPublicActions";
import { connect } from "react-redux";
import {getFileByFileId} from '../../../widget/api/GoogleDriveApi';
import { injectIntl } from 'react-intl';


import "./picker.scss";

class PickerApp extends Component {
    constructor(props) {
      super(props);
      this.state = {token: ''}
      this.sendIds = this.sendIds.bind(this);
      this.lang = Wix.Utils.getLocale() || 'en';
      this.createPicker = this.createPicker.bind(this);
      this.compId = Wix.Utils.getOrigCompId();
      this.userName = '';
      PickerApp.clearIntervalGetToken = this.clearIntervalGetToken()
    }
    componentDidMount() {
        window.loginSuccess = data => {
          let datapublicObj = {
            compId: this.compId,
            expiry_date: data.expiry_date,
            signedAt: new Date(),
            userName: data.userName,
            scope: data.scope
          };
           if(data.scope.includes('https://www.googleapis.com/auth/drive.file')){
                 this.props.updateErrorConnect(false);
                 this.props.setDataPublic(datapublicObj);
                 window.localStorage.setItem('token', JSON.stringify(data.access_token));
                 const dataTrigger = {key: 'connectNoSelect', value: {compId: this.compId, connectNoSelect: true}};
                  Wix.Settings.triggerSettingsUpdatedEvent(dataTrigger, this.compId);
           }
           else{
             datapublicObj = {
                scope: data.scope
              };
            this.props.setDataPublic(datapublicObj);
            this.props.updateErrorConnect(true);
           }
        };
        this.getDataPublic(this.compId);
        this._isEditorX = false;
        Wix.Styles.getStyleParams(styleParams => {
            if(styleParams.booleans.responsive) {
                this._isEditorX = true;
            }
        })
    }

    componentWillUnmount(){
        this.clearIntervalGetToken();
    }
    _collectData = () => {
        return {
            new_status: this.state.fileId ? this.mimeType : '',//mimeType type
        };
    };

    getDataPublic = compId => {
        this.getAccessToken();
        Wix.Data.Public.get(compId, { scope: "COMPONENT" }, data => {
            try {
                if (data[compId].userName) {
                    this.userName = data[compId].userName;
                    //this.getAccessToken();
                }
            }
            catch(err) {}
            if (!(this.props.dataPublic && this.props.dataPublic.disconnect == true))
                this.props.setDataPublic();
        });
    };
    onDisconnect = () => {
        const dataFile = { key: 'id', value: { id: parameters['DEFAULT_FILE'], src: parameters['DEFAULT_FILE_SRC'], compId: this.compId } };
        Wix.Settings.triggerSettingsUpdatedEvent(dataFile, this.compId);
        const datapublicObj = {
            "compId": this.compId,
            "access_token": null,
            "token": null,
            "scope":null,
            "signedAt": null,
            "activeFileId": parameters['DEFAULT_FILE'],
            "src": parameters['DEFAULT_FILE_SRC'],
            "isSignleFile": true,
            "userName": null,
            "disconnect": true
        };
        clearIntervalGetToken();
        this.props.setDataPublic(datapublicObj);
        this.props.updateConnected(false);
        axios.post("api/deleteAccessToken" + httpRequest.getUrlQuery())
             .then(res => { console.log(res)} )
             .catch(err => { console.log(err)});
    }

    authenticate_google_OAuthtoken(access_token)
    {
        if(!access_token) return true;
        const url = 'https://www.googleapis.com/oauth2/v1/tokeninfo?access_token='+access_token;
        axios.get(url).then(res => {
            if(res.data.user_id)
                return true;
        }).catch(err => {
            console.log(err)
            return false;
        });
    }

    getAccessToken() {

        this.refresh = () => {
            axios.get("/api/token" + httpRequest.getUrlQuery())
            .then(res => {
                let json = JSON.parse(res.data);
                if (json.access_token) {
                    window.localStorage.setItem('token', JSON.stringify(json.access_token));
                    this.authenticate_google_OAuthtoken(json.access_token);
                }

            }).catch(err => {
                clearInterval(this.refresh);
            });
    }
        clearInterval(this.refresh);
        this.refresh();
        setInterval(this.refresh, 300000);
    }

    clearIntervalGetToken() {
        clearInterval(this.refresh);
    }
    sendIds(data) {
        if (data.action === window.google.picker.Action.CANCEL) {
            Wix.closeWindow();
        }
        if (data.action === window.google.picker.Action.PICKED) {
            const fileId = data.docs[0].id;
            const resourceKey =  data.docs[0].resourceKey;
            const token = window.localStorage.getItem('token') !== null && window.localStorage.getItem('token') !== "undefined" ? JSON.parse(window.localStorage.getItem('token')): '';
            const isSignleFile = data.docs[0].mimeType !== parameters['TYPE_FOLDER'];
            const dataLoader = { key: 'loader', value: {compId: this.compId} };
            const datapublicObj = { "compId": this.compId, "activeFileId": fileId, "mimeType": data.docs[0].mimeType, "isSignleFile": isSignleFile, "editable": false ,resourceKey:resourceKey};
            let src = data.docs[0].embedUrl;
            WixBiService.triggerEvent('select_file_or_folder', {
                type: isSignleFile ? 'file' : 'folder'
            })
            Wix.Settings.triggerSettingsUpdatedEvent(dataLoader, this.compId);
            let ownedByMe = data.viewToken[2].ownedByMe
            retrievePermissionsListByFileId(fileId, (permissions) => {
                if(permissions) {
                    permissions.forEach((permission) => {
                          if(permission.type === 'domain' && permission.name) {
                            ownedByMe = false;
                         }
                         if(permission.role === 'writer') {
                            if(data.docs[0].mimeType.includes('google') && !data.docs[0].mimeType.includes('form'))
                                src = data.docs[0].url;
                        }
                    });
                }
                const dataFile = { key: 'id', value: { compId: this.compId, id: fileId, token: token, compId: this.compId, mimeType: data.docs[0].mimeType, isSignleFile, src,resourceKey:resourceKey } };
                let title = isSignleFile ? this.props.intl.formatMessage({id: 'settings.popup.MakeFilePublic'}) : this.props.intl.formatMessage({id: 'settings.popup.MakeFolderPublic'})
                Wix.closeWindow({
                    datapublicObj,
                    dataFile: dataFile,
                    fileId: fileId,
                    resourceKey:resourceKey,
                    title: title ,
                    noPermissionTitle: this.props.intl.formatMessage({id: 'settings.popup.noPermission'}),
                    ownedByMe: ownedByMe
                });
            });
        }
    }
    createPicker(google, oauthToken) {
        const isEditorStudio = wixService.getParamFromURL('isEditorStudio') === 'true';
        let origin = window.location.protocol + "//" ;

        if (this._isEditorX && !isEditorStudio){
            origin =  origin + "create.editorx.com";
        }
        else {
            origin = origin + "editor.wix.com";
        }
        const titleSelect = this.props.intl.formatMessage({id: 'settings.main.button.select'});
        const Starred = this.props.intl.formatMessage({id: 'settings.main.picker.starred'});
        const picker = new google.picker.PickerBuilder()
            .addView(new google.picker.DocsView(google.picker.ViewId.DOCS)
                .setIncludeFolders(true)
                .setSelectFolderEnabled(true)
                .setOwnedByMe(true))
            .addView(new google.picker.DocsView(google.picker.ViewId.DOCS)
                .setIncludeFolders(true)
                .setSelectFolderEnabled(true)
                .setOwnedByMe(false))
            .addView(google.picker.ViewId.RECENTLY_PICKED)
            .addView(new google.picker.DocsView(google.picker.ViewId.DOCS)
                .setSelectFolderEnabled(true)
                .setLabel(Starred)
                .setStarred(true))
                .setDeveloperKey(process.env.REACT_APP_KEY)
                .setAppId(process.env.REACT_APP_CLIENT_ID)
                .setOAuthToken(oauthToken)
            .setTitle(titleSelect)
            .setLocale(this.lang)
            .setSize(1000, 640)
            .setOrigin(origin)
            .setCallback(this.sendIds);
        picker.build().setVisible(true);
    }

    render() {
        let token = window.localStorage.getItem('token') !== null && typeof window.localStorage.getItem('token') !== "undefined" ? JSON.parse(window.localStorage.getItem('token')): '';
        if (!token) {this.getAccessToken()}
        return (
            <GooglePicker
                children= {this.props.children}
                disconnect={this.props.disconnect}
                token={token}
                connect={this.props.connect}
                clientId={process.env.REACT_APP_CLIENT_ID}
                scope={parameters['SCOPE']}
                onChange={data => console.log('on change:', data)}
                multiselect={true}
                navHidden={true}
                authImmediate={false}
                viewId={'FOLDERS'}
                createPicker={this.createPicker}
            >
            </GooglePicker>
            );

    }

}

const mapDispatchToProps = dispatch => ({
  updateConnected: showBtn => dispatch(updateConnect(showBtn)),
  setDataPublic: dataPublic => dispatch(setDataPublic(dataPublic)),
  updateErrorConnect: showError => dispatch(updateErrorConnect(showError)),
});

const mapStateToProps = state => ({
  showBtn: state.userConnectReducer.showBtn,
  showError: state.userConnectReducer.showError,
  instanceId: state.commonReducer.instanceId,
  compId: state.commonReducer.compId,
  dataPublic: state.dataPublicReducer.dataPublic,
  isUserAccountExist: state.userAccountWizardReducer.isUserAccountExist
});

export default injectIntl(connect(
  mapStateToProps,
  mapDispatchToProps
)(PickerApp));

function clearIntervalGetToken() {
    const picker = new PickerApp()
    picker.clearIntervalGetToken();
}
export {clearIntervalGetToken}


// WEBPACK FOOTER //
// ./src/settings/components/picker/Picker.js